import { render, staticRenderFns } from "./TrasferrerDropDown.vue?vue&type=template&id=1b28c31a"
import script from "./TrasferrerDropDown.vue?vue&type=script&lang=js"
export * from "./TrasferrerDropDown.vue?vue&type=script&lang=js"
import style0 from "./TrasferrerDropDown.vue?vue&type=style&index=0&id=1b28c31a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports